import Vue from 'vue'
import Router from 'vue-router'
import RoutesFront from './Front'
import RoutesBack from './Back'
import Main from '../components/Main.vue';

Vue.use(Router)

let currentLang = localStorage.getItem('lang')
if (!currentLang) {
  currentLang = 'en'
}
function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/components/${view}.vue`)
}
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: 'Home',
      meta: {
        isPublic: true
      }
    },
    {
      path: '/',
      redirect: `/${currentLang}`,
      meta: {
        isPublic: true
      }
    },
    {
      path: '/:lang',
      component: Main,
      meta: {
        isPublic: true
      },
      children: RoutesFront
    },
    {
      path: '/:lang/:console/dashboard',
      component: loadView('Dashboard'),
      meta: {
        isPublic: false
      },
      children: RoutesBack
    }
  ]
})
